import Modal from "../../../modal/Modal";

import CheckSvgComponent from "../CheckSvgComponent";

import styles from "./styles.module.scss";

const FeedbackComponent = (props) => {
  const {show} = props;

  return (
    <>
      <Modal visible={show}>
        <div className={styles["assessment-wrapper"]}>
          <CheckSvgComponent />
          <div className={styles.title}>Thanks for feedback</div>
          <div className={styles.description}>
            Your feedback is valuable to us.
          </div>
          {/* <div className={styles["button-wrapper"]}>
             <Button
              label="Go to course"
              buttonVariant={BUTTON_VARIANTS.PRIMARY}
              onClick={handleGoToCourse}
              className={styles.button}
            />
          </div> */}
        </div>
      </Modal>
    </>
  );
};

export default FeedbackComponent;
